import { render } from "./Edit.vue?vue&type=template&id=1933c611"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/superAdmin/ecole/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1933c611"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1933c611', __exports__)) {
    console.log('reload')
    api.reload('1933c611', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=1933c611", () => {
    console.log('re-render')
    api.rerender('1933c611', render)
  })

}


export default __exports__